<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 报销新增表单 -->
      <el-form
        ref="addReimbursementForm1"
        :rules="rules"
        :model="addReimbursementForm"
        v-if="showForm==='showFormAdd'"
        label-position="left"
        label-width="120px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" v-else>
              <!-- <el-select
                style="width:100%"
                v-model="addReimbursementForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                @visible-change="handleProjectSelectBlur1"
                :filter-method="projectFilter"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectListSub"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
                <div
                  v-if="projectList.length > moreNum && projectListSub.length>=moreNum"
                  class="search-keyword-more"
                >只显示前{{moreNum}}条库中结果，请完善搜索关键字</div>
              </el-select>-->
<!--  -->  

<!-- 在本地搜索 -->
              <!-- <el-select
                style="width:100%"
                v-model="addReimbursementForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select> -->

              <!-- 远程搜索 -->
              <el-select
                style="width:100%"
                v-model="addReimbursementForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>

            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addReimbursementForm.member">
              <span
                v-if="addReimbursementForm.member"
                style="color:#666;font-size:16px"
              >{{addReimbursementForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*请分条列出事件的发生时间，地点，人物和金额；附件需包含支付截图，要求条理清晰（如有发票请上传发票，并打印发票附报销单交于财务室）。</div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="$store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addReimbursementForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 报销类型 -->
            <el-form-item label="报销类型" style="margin-bottom:0px;">
              <!-- <el-radio-group v-model="addReimbursementForm.type" :disabled="draftDisable">
                <el-radio label="1">项目实施相关费用</el-radio>
                <el-radio label="2">业务相关费用</el-radio>
                <el-radio label="3">招待费</el-radio>
                <el-radio label="4">其他（写备注里）</el-radio>
              </el-radio-group>-->
              <div class="myradio">
                <div
                  class="myradioItem"
                  @click="handleTypeChange('1')"
                  :class="addReimbursementForm.type=='1'?'myradioItemCurrent1':''"
                >项目实施相关费用</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('2')"
                  :class="addReimbursementForm.type=='2'?'myradioItemCurrent':''"
                >业务相关费用</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('6')"
                  :class="addReimbursementForm.type=='6'?'myradioItemCurrent':''"
                >业务拓展费</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('3')"
                  :class="addReimbursementForm.type=='3'?'myradioItemCurrent':''"
                >招待费</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('5')"
                  :class="addReimbursementForm.type=='5'?'myradioItemCurrent':''"
                >出图费</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('4')"
                  :class="addReimbursementForm.type=='4'?'myradioItemCurrent':''"
                >其他（写备注里）</div>
              </div>
            </el-form-item>
            
            <!-- 事前报备明细 -->
            <el-form-item label="事前报备">
              <div style="width:100%">
                <el-row style="width:100%;margin-bottom:10px;">
                  <el-button class="AddUser" @click="detailsShow=true" v-if="!detailsShow">查看报备明细</el-button>
                  <el-button class="AddUser" @click="detailsShow=false" v-else>隐藏报备明细</el-button>
                </el-row>

                <el-table
                  :data="addReimbursementForm.reportb_list"
                  style="width: 100%"
                  border
                  v-if="detailsShow"
                  :header-cell-style="{background:'#F4F5F6'}"
                >
                  <el-table-column show-overflow-tooltip align="center" prop="title" label="报备内容">
                    <template slot-scope="scope">
                      <span>{{scope.row.title}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="total" label="报备金额">
                    <template slot-scope="scope">
                      <span>{{scope.row.total}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <!-- 报销内容 -->
            <el-form-item label="报销内容">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入报销内容"
                v-model="addReimbursementForm.title"
              ></el-input>
            </el-form-item>
            <!-- 目的地  --  日期 -->
            <div class="inputTwoRow">
              <el-form-item label="目的地" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  placeholder="目的地"
                  v-model="addReimbursementForm.destination"
                ></el-input>
              </el-form-item>
              <el-form-item label="日期" style="width:50%">
                <el-date-picker
                  :disabled="draftDisable"
                  style="width:100%"
                  v-model="addReimbursementForm.date"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </div>
            <!-- 开车区间  --  开车里程 -->
            <div class="inputTwoRow">
              <el-form-item label="开车区间" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  placeholder="开车区间"
                  v-model="addReimbursementForm.driving_range"
                ></el-input>
              </el-form-item>

              <el-form-item label="开车里程" style="width:50%">
                <el-input
                  type="number"
                  :disabled="draftDisable"
                  placeholder="开车里程"
                  v-model="addReimbursementForm.driving_mileage"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">km</div>
              </el-form-item>
            </div>
            <!-- 开车费用  --  住宿 -->
            <div class="inputTwoRow">
              <el-form-item class="computedDisable" label="开车费用" style="width:50%">
                <el-input placeholder="开车费用" disabled v-model="driveMoney"></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
              <el-form-item label="住宿" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  type="number"
                  placeholder="住宿"
                  v-model="addReimbursementForm.hotel"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
            </div>
            <!-- 交通费  --  餐费 -->
            <div class="inputTwoRow">
              <el-form-item label="交通费" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  type="number"
                  placeholder="交通费"
                  v-model="addReimbursementForm.traffic"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
              <el-form-item label="餐费" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  type="number"
                  placeholder="餐费"
                  v-model="addReimbursementForm.food_bill"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
            </div>

            <!-- 出图费  --  其他 -->
            <div class="inputTwoRow">
              <el-form-item label="出图费" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  type="number"
                  placeholder="出图费"
                  v-model="addReimbursementForm.rendering_fee"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
              <el-form-item label="其他" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  type="number"
                  placeholder="其他"
                  v-model="addReimbursementForm.other"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
            </div>

            <!-- 有无发票 -->
            <div class="inputTwoRow">
              <el-form-item label="有发票" style="width:50%">
                <el-input
                  placeholder="请填写有发票金额"
                  :disabled="draftDisable"
                  v-model="addReimbursementForm.bill"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
              <el-form-item class="computedDisable" label="无发票" style="width:50%">
                <el-input
                  placeholder="请填写无发票金额"
                  disabled
                  v-model="no_bill"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
            </div>

            <!-- 总计 -->
            <el-form-item class="computedDisable" label="总计" style="margin-bottom:20px">
              <el-input placeholder="总计" disabled v-model="sumMoney"></el-input>
              <div style="width:40px;text-align:center;line-height:40px;">元</div>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                placeholder="请输入备注信息"
                type="textarea"
                :disabled="draftDisable"
                v-model="addReimbursementForm.remark"
              ></el-input>
            </el-form-item>
            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:0px">
              <upload-img
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-img>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 报销审批表单 -->
      <el-form
        ref="addReimbursementForm2"
        :rules="rules"
        :model="addReimbursementForm"
        v-if="showForm==='showFormHandle'"
        label-position="left"
        label-width="120px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addReimbursementForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('reimbursement',addReimbursementForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addReimbursementForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('reimbursement',addReimbursementForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addReimbursementForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div
          class="diaForm_box diaEditFormBox"
          v-if="addReimbursementForm.is_edit=='1' || (addReimbursementForm.project_list && addReimbursementForm.project_list.length>0)"
        >
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <!-- <el-select
                style="width:100%"
                v-model="addReimbursementForm.project_id"
                filterable
                v-if="addReimbursementForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                @visible-change="handleProjectSelectBlur1"
                :filter-method="projectFilter"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectListSub"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
                <div
                  v-if="projectList.length > moreNum && projectListSub.length>=moreNum"
                  class="search-keyword-more"
              >只显示前{{moreNum}}条库中结果，请完善搜索关键字</div>-->
              <el-select
                style="width:100%"
                v-model="addReimbursementForm.project_id"
                filterable
                v-if="addReimbursementForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                :key="items.project_id"
                v-for="(items,index) in addReimbursementForm.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addReimbursementForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name }}</span>
              </span>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addReimbursementForm.member">
              <span
                v-if="addReimbursementForm.member"
                style="color:#666;font-size:16px"
              >{{addReimbursementForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*请分条列出事件的发生时间，地点，人物和金额；附件需包含支付截图，要求条理清晰（如有发票请上传发票，并打印发票附报销单交于财务室）。</div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="addReimbursementForm.is_edit=='1' && $store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addReimbursementForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 报销类型 -->
            <el-form-item label="报销类型" style="margin-bottom:0px;">
              <!-- <el-radio-group
                v-model="addReimbursementForm.type"
                v-if="addReimbursementForm.is_edit=='1'"
              >
                <el-radio label="1">项目实施相关费用</el-radio>
                <el-radio label="2">业务相关费用</el-radio>
                <el-radio label="3">招待费</el-radio>
                <el-radio label="4">其他（写备注里）</el-radio>
              </el-radio-group>-->

              <div class="myradio" v-if="addReimbursementForm.is_edit=='1'">
                <div
                  class="myradioItem"
                  @click="handleTypeChange('1')"
                  :class="addReimbursementForm.type=='1'?'myradioItemCurrent1':''"
                >项目实施相关费用</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('2')"
                  :class="addReimbursementForm.type=='2'?'myradioItemCurrent':''"
                >业务相关费用</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('6')"
                  :class="addReimbursementForm.type=='6'?'myradioItemCurrent':''"
                >业务相关费用</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('3')"
                  :class="addReimbursementForm.type=='3'?'myradioItemCurrent':''"
                >招待费</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('5')"
                  :class="addReimbursementForm.type=='5'?'myradioItemCurrent':''"
                >出图费</div>
                <div
                  class="myradioItem"
                  @click="handleTypeChange('4')"
                  :class="addReimbursementForm.type=='4'?'myradioItemCurrent':''"
                >其他（写备注里）</div>
              </div>
              <div
                v-else
                class="myradioItemShow"
                :class="addReimbursementForm.type=='1'?'myradioItemShowRed':''"
              >
                <span v-if="addReimbursementForm.type=='1'">项目实施相关费用</span>
                <span v-if="addReimbursementForm.type=='2'">业务相关费用</span>
                <span v-if="addReimbursementForm.type=='6'">业务拓展费</span>
                <span v-if="addReimbursementForm.type=='3'">招待费</span>
                <span v-if="addReimbursementForm.type=='5'">出图费</span>
                <span v-if="addReimbursementForm.type=='4'">其他（写备注里）</span>
              </div>
            </el-form-item>
                        <!-- 到账明细 -->
            <el-form-item label="事前报备">
              <div style="width:100%">
                <el-row style="width:100%;margin-bottom:10px;">
                  <el-button class="AddUser" @click="detailsShow=true" v-if="!detailsShow">查看报备明细</el-button>
                  <el-button class="AddUser" @click="detailsShow=false" v-else>隐藏报备明细</el-button>
                </el-row>

                <el-table
                  :data="addReimbursementForm.reportb_list"
                  style="width: 100%"
                  border
                  v-if="detailsShow"
                  :header-cell-style="{background:'#F4F5F6'}"
                >
                  <el-table-column show-overflow-tooltip align="center" prop="title" label="报备内容">
                    <template slot-scope="scope">
                      <span>{{scope.row.title}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="total" label="报备金额">
                    <template slot-scope="scope">
                      <span>{{scope.row.total}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <!-- 报销内容 -->
            <el-form-item label="报销内容">
              <el-input
                placeholder="请输入报销内容"
                v-model="addReimbursementForm.title"
                v-if="addReimbursementForm.is_edit=='1'"
              ></el-input>
              <span style="color:#666;font-size:16px" v-else>{{addReimbursementForm.title}}</span>
            </el-form-item>
            <!-- 目的地  --  日期 -->
            <div class="inputTwoRow">
              <el-form-item label="目的地" style="width:50%">
                <el-input
                  placeholder="目的地"
                  v-if="addReimbursementForm.is_edit=='1'"
                  v-model="addReimbursementForm.destination"
                ></el-input>
                <span style="color:#666;font-size:16px" v-else>{{addReimbursementForm.destination}}</span>
              </el-form-item>
              <el-form-item label="日期" style="width:50%">
                <el-date-picker
                  style="width:100%"
                  v-model="addReimbursementForm.date"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                  v-if="addReimbursementForm.is_edit=='1'"
                ></el-date-picker>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.date}}</span>
              </el-form-item>
            </div>
            <!-- 开车区间  --  开车里程 -->
            <div class="inputTwoRow">
              <el-form-item label="开车区间" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  placeholder="开车区间"
                  v-model="addReimbursementForm.driving_range"
                ></el-input>
                <span
                  v-else
                  style="color:#666;font-size:16px"
                >{{addReimbursementForm.driving_range}}</span>
              </el-form-item>
              <el-form-item label="开车里程" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  placeholder="开车里程"
                  type="number"
                  v-model="addReimbursementForm.driving_mileage"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px"
                >km</div>
                <span
                  v-else
                  style="color:#666;font-size:16px"
                >{{addReimbursementForm.driving_mileage+'KM'}}</span>
              </el-form-item>
            </div>
            <!-- 开车费用  --  住宿 -->
            <div class="inputTwoRow">
              <el-form-item label="开车费用" class="computedDisable" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  placeholder="开车费用"
                  disabled
                  v-model="driveMoney"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span
                  v-else
                  style="color:#666;font-size:16px"
                >{{addReimbursementForm.driving_expenses}}</span>
              </el-form-item>
              <el-form-item label="住宿" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  type="number"
                  placeholder="住宿"
                  v-model="addReimbursementForm.hotel"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.hotel}}</span>
              </el-form-item>
            </div>
            <!-- 交通费  --  餐费 -->
            <div class="inputTwoRow">
              <el-form-item label="交通费" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  type="number"
                  placeholder="交通费"
                  v-model="addReimbursementForm.traffic"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.traffic}}</span>
              </el-form-item>
              <el-form-item label="餐费" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  type="number"
                  placeholder="餐费"
                  v-model="addReimbursementForm.food_bill"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.food_bill}}</span>
              </el-form-item>
            </div>

            <!-- 出图费  --  其他 -->
            <div class="inputTwoRow">
              <el-form-item label="出图费" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  type="number"
                  placeholder="出图费"
                  v-model="addReimbursementForm.rendering_fee"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.rendering_fee}}</span>
              </el-form-item>
              <el-form-item label="其他" style="width:50%">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  type="number"
                  placeholder="其他"
                  v-model="addReimbursementForm.other"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.other}}</span>
              </el-form-item>
            </div>

            <!-- 有无发票 -->
            <div class="inputTwoRow">
              <!-- 有发票 -->
              <el-form-item label="有发票" style="width:50%">
                <el-input
                  placeholder="请填写有发票金额"
                  v-if="addReimbursementForm.is_edit=='1'"
                  v-model="addReimbursementForm.bill"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.bill}}</span>
              </el-form-item>
              <!-- 无发票 -->
              <el-form-item class="computedDisable" label="无发票" style="width:50%">
                <el-input
                  placeholder="请填写无发票金额"
                  v-if="addReimbursementForm.is_edit=='1'"
                  disabled
                  v-model="no_bill"
                ></el-input>
                <div
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.no_bill}}</span>
              </el-form-item>
            </div>

            <!--  总计 -->
            <el-form-item label="总计" class="computedDisable" style="width:100%">
              <el-input
                v-if="addReimbursementForm.is_edit=='1'"
                placeholder="总计"
                disabled
                v-model="sumMoney"
              ></el-input>
              <div
                v-if="addReimbursementForm.is_edit=='1'"
                style="width:40px;text-align:center;line-height:40px;"
              >元</div>
              <span v-else style="color:#666;font-size:16px">{{addReimbursementForm.total}}</span>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                placeholder="请输入备注信息"
                type="textarea"
                v-if="addReimbursementForm.is_edit=='1'"
                v-model="addReimbursementForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addReimbursementForm.remark"
              ></el-input>
            </el-form-item>

            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-img
                :isSubmit="addReimbursementForm.is_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-img>
            </el-form-item>
          </div>
        </div>

        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addReimbursementForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 报销新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft!='1'"
        @click="handleAddReimbursementSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft!='1'"
        @click="handleAddReimbursementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 报销编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1' && !draftDisable"
        @click="handleEditReimbursementSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1' && !draftDisable"
        @click="handleEditReimbursementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 报销重新提交按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormHandle' && addReimbursementForm.is_edit=='1'"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormHandle' && addReimbursementForm.is_edit=='1'"
        @click="handleEditReimbursementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 签名组件 -->
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addReimbursementForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addReimbursementForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addReimbursementForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择" clearable>
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addReimbursementForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addReimbursementForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addReimbursementForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="addReimbursementForm.approval_status=='1'"
          @click="handleFinnaceApproval('-1','reimbursement',addReimbursementForm.id)"
          :disabled="disableLimit"
          style="background:#f4a029;"
          class="search"
        >驳回</el-button>
        <el-button
          v-if="addReimbursementForm.approval_status=='1'"
          @click="handleFinnaceApproval('1','reimbursement',addReimbursementForm.id)"
          :disabled="disableLimit"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import UploadImg from '../../../components/UploadImg'
import SignDialog from '../../../components/SignDialog'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      detailsShow: false,
      approveVisible: false,
      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,

      imgList: [],
      detailsImgList: [],

      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      tiemID1: null,
      timeDou: 100,
      // 新增报销
      addReimbursementForm: {
        project_list: [],
        type: '1',
        title: '',
        destination: '',
        date: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        rendering_fee: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: '',
        project_id: [],
        bill: '',
        no_bill: '',
        reportb_list: [],
      

      },
      approvalRemark: '',
      sendData: {
      number: '',
      pte_name: '',
      contract_money: '',
      settlement_show: '',
    },
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },


      project_search_list:[]
    }
  },
  props: [],
  components: {
    UploadImg,
    SignDialog,
  },
  watch: {
    '$store.state.process.finance.formData'(newval, olval) {
      this.addReimbursementForm = this.normalizeReimbursementFormData(newval)
    },
    '$store.state.process.finance.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addReimbursementForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    // 默认驳回节点是当前节点
    'addReimbursementForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
          console.log('this.k_code', this.k_code)
        } else {
          this.k_code = ''
        }
      },
    },
  },
  methods: {
   normalizeReimbursementFormData(formData = {}) {
      const nextFormData = JSON.parse(
        JSON.stringify(
          formData || {}
        )
      )
      if (
        nextFormData.rendering_fee === undefined ||
        nextFormData.rendering_fee === null ||
        nextFormData.rendering_fee === ''
      ) {
        nextFormData.rendering_fee = 0.0
      }
      return nextFormData
    },
   // 按搜索条件查找，不在本地进行查找
  async projectSearch(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      param.append('type', '1')
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },


    handleTypeChange(val) {
      if (this.draftDisable) {
        return
      }
      this.addReimbursementForm.type = val
    },
    ...mapMutations('process/finance', ['getDialogVisible', 'userFilter']),
    projectFilter(query = '') {
      let arr = this.projectList.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/finance/setprojectListSub', arr)
      }
    },
    handleProjectSelectBlur1(val) {
      if (!val) {
        if (this.projectList.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList
          )
        }

        console.log('this.projectListSub', this.projectListSub)
      }
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *编辑报销提交
    async handleEditReimbursementSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        // 判断是不是草稿
        if (this.addReimbursementForm.is_draft == '1') {
          this.$refs.addReimbursementForm1.validate(async (valid) => {})
        } else {
          this.$refs.addReimbursementForm2.validate(async (valid) => {})
        }
      }
      this.disableLimit = true
      if (this.addReimbursementForm.date == null) {
        this.addReimbursementForm.date = ''
      }

      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        // return console.log(
        //   'addReimbursementForm.project_id',
        //   this.addReimbursementForm.isOld_project_id
        // )
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addReimbursementForm.id)

        param.append('preset_member', this.addReimbursementForm.preset_member)

        param.append('type', this.addReimbursementForm.type)
        param.append('title', this.addReimbursementForm.title)
        param.append('destination', this.addReimbursementForm.destination)
        param.append('date', this.addReimbursementForm.date)
        param.append('driving_range', this.addReimbursementForm.driving_range)
        param.append(
          'driving_mileage',
          this.addReimbursementForm.driving_mileage
        )
        param.append('driving_expenses', this.driveMoney)
        param.append('hotel', this.addReimbursementForm.hotel)
        param.append('traffic', this.addReimbursementForm.traffic)
        param.append('food_bill', this.addReimbursementForm.food_bill)
        param.append('rendering_fee', this.addReimbursementForm.rendering_fee)
        param.append('other', this.addReimbursementForm.other)
        param.append('total', this.sumMoney)

        param.append('bill', this.addReimbursementForm.bill)
        param.append('no_bill', this.no_bill)
        param.append('remark', this.addReimbursementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // // 单选
        // if (
        //   Array.isArray(this.addReimbursementForm.isOld_project_id) &&
        //   !this.addReimbursementForm.project_id
        // ) {
        //   param.append(
        //     'project_id',
        //     this.addReimbursementForm.isOld_project_id.join(',')
        //   )
        // } else {
        //   param.append('project_id', this.addReimbursementForm.project_id)
        // }
        // 多选
        // param.append(
        //   'project_id',
        //   this.addReimbursementForm.project_id.join(',')
        // )
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append(
            'project_id',
            this.addReimbursementForm.project_id.join(',')
          )
        }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reimbursement_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false

        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },

    // *报销点击提交
    async handleAddReimbursementSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        this.$refs.addReimbursementForm1.validate(async (valid) => {
          //   如果校验失败
          // if (valid == false) return this.$message.error('角色信息不合规')
          // 如果校验成功
        })
      }

      this.disableLimit = true
      if (this.addReimbursementForm.date == null) {
        this.addReimbursementForm.date = ''
      }
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('preset_member', this.addReimbursementForm.preset_member)

        param.append('type', this.addReimbursementForm.type)
        param.append('title', this.addReimbursementForm.title)
        param.append('destination', this.addReimbursementForm.destination)
        param.append('date', this.addReimbursementForm.date)
        param.append('driving_range', this.addReimbursementForm.driving_range)
        param.append(
          'driving_mileage',
          this.addReimbursementForm.driving_mileage
        )
        param.append('driving_expenses', this.driveMoney)
        param.append('hotel', this.addReimbursementForm.hotel)
        param.append('traffic', this.addReimbursementForm.traffic)
        param.append('food_bill', this.addReimbursementForm.food_bill)
        param.append('rendering_fee', this.addReimbursementForm.rendering_fee)
        param.append('other', this.addReimbursementForm.other)
        param.append('total', this.sumMoney)

        param.append('bill', this.addReimbursementForm.bill)
        param.append('no_bill', this.no_bill)
        param.append('remark', this.addReimbursementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // 多选
        // param.append(
        //   'project_id',
        //   this.addReimbursementForm.project_id.join(',')
        // )
        // // 单选
        // param.append('project_id', this.addReimbursementForm.project_id)
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append(
            'project_id',
            this.addReimbursementForm.project_id.join(',')
          )
        }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reimbursement_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },
    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/finance/getReimbursementList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/finance/getReimbursementList')
      }
    },
    // 选择项目名称1
    async handleProjectSelectChange1(val) {
     console.log('val',val)
     console.log(this.addReimbursementForm)
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addReimbursementForm.project_id = [val[0]]
      }
      this.sendData = {
        number: '',
        pte_name: '',
        contract_money: '',
        settlement_show: '',
      }
      // *、实时请求到账金额
      if (this.addReimbursementForm.project_id.length <= 0) {
        // this.sendNumber = ''
        this.sendData.number = ''
      }
      if (
        (this.showForm == 'showFormAdd' ||
          this.showForm == 'showFormHandle') &&
        this.addReimbursementForm.project_id.length > 0
        
      ) {
        console.log(222)
        let paramss = new FormData()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('cache_department_id', this.cache_department_id)
        paramss.append('company_id', this.company_id)

        paramss.append(
          'project_id',
          `[${this.addReimbursementForm.project_id.join(',')}]`
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_reportb_by_project_id',
          data: paramss,
        }).then((results) => {
          if (results.data.code != 200)
            return this.$message.error(results.data.datas.msg)
          // this.sendNumber = results.data.datas.arrival
          this.addReimbursementForm.reportb_list = results.data.datas.list
          this.sendData.number = results.data.datas.reportb
        })
      }
       
      if (this.$store.state.process.finance.isFromProjectBar) {
        
        this.sendData.number = ''
        let paramss = new FormData()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('cache_department_id', this.cache_department_id)
        paramss.append('company_id', this.company_id)

        paramss.append(
          'project_id',
          `[${this.$store.state.process.finance.projectId}]`
        )

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_reportb_by_project_id',
          data: paramss,
        }).then((results) => {
          if (results.data.code != 200)
            return this.$message.error(results.data.datas.msg)
          // this.sendNumber = results.data.datas.arrival
          this.sendData.number = results.data.datas.reportb
        })
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },

  async created() {
    this.addReimbursementForm = this.normalizeReimbursementFormData(
      this.$store.state.process.finance.formData
    )
    if (this.addReimbursementForm.annex) {
      this.imgList = this.addReimbursementForm.annex
      this.detailsImgList = this.addReimbursementForm.annex
    }
    this.disableLimit = false
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  mounted() {},
  computed: {
    ...mapState('process/finance', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
    // 总计
    sumMoney() {
      var dMoney = parseFloat(
        (this.addReimbursementForm.driving_mileage * 1.25).toFixed(2)
      )
      console.log('dMoney1', dMoney)
      return (
        dMoney +
        this.addReimbursementForm.hotel * 1.0 +
        this.addReimbursementForm.traffic * 1.0 +
        this.addReimbursementForm.food_bill * 1.0 +
        this.addReimbursementForm.rendering_fee * 1.0 +
        this.addReimbursementForm.other * 1.0
      ).toFixed(2)
    },
    // 开车费用
    driveMoney() {
      return (this.addReimbursementForm.driving_mileage * 1.25).toFixed(2)
    },
    //无发票账单
    no_bill() {
      var dMoney = parseFloat(
        (this.addReimbursementForm.driving_mileage * 1.25).toFixed(2)
      )
      console.log('dMoney1', dMoney)
      return (
        dMoney +
        this.addReimbursementForm.hotel * 1.0 +
        this.addReimbursementForm.traffic * 1.0 +
        this.addReimbursementForm.food_bill * 1.0 +
        this.addReimbursementForm.rendering_fee * 1.0 +
        this.addReimbursementForm.other * 1.0-
        this.addReimbursementForm.bill
      ).toFixed(2)
    },
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>
